/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_EN = {
  "  Checked by (signature)": "  Checked by (signature)",
  "! 3 of 4 types required:": "! 3 of 4 types required:",
  "! Min. 14 characters": "! Min. 14 characters",
  "! No name/username parts": "! No name/username parts",
  "! No spaces": "! No spaces",
  "/ occasion": "/ occasion",
  "A new password should be different than the current one": "A new password should be different than the current one",
  "ACCEPTED": "ACCEPTED",
  "Active flights": "Active flights",
  "Add deicing/anti-icing": "Add deicing/anti-icing",
  "Add description": "Add description",
  "Add description if there is a irregularity!": "Add description if there is a irregularity!",
  "Add line": "Add line",
  "Add location where item was found": "Add location where item was found",
  "Add note": "Add note...",
  "add occasion": "add occasion",
  "Add other location": "Add other location",
  "Add row": "Add row",
  "Add storage location": "Add storage location",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Add your recovery email so we can send you a code if you ever forget your password.",
  "additional services": "Additional services",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.",
  "Agent's name:": "Agent's name:",
  "Agent's signature:": "Agent's signature:",
  "Aircraft Damage": "Aircraft Damage",
  "Aircraft type": "Aircraft type",
  "Airline": "Airline",
  "All": "All",
  "ALL": "ALL",
  "All Airlines with Stocks": "All Airlines with Stocks",
  "An error occurred while trying to verify your email address.": "An error occurred while trying to verify your email address.",
  "and": " and ",
  "and/or": "and/or",
  "Anti-icing": "Anti-icing",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Any email with @aviapartner.aero or @aviavip.com is not accepted!",
  "APPLY": "APPLY",
  "approved": "approved",
  "Apr": "Apr",
  "Archived": "Archived",
  "Are you sure you want to change your password?": "Are you sure you want to change your password?",
  "Are you sure you want to exit the current process?": "Are you sure you want to exit the current process?",
  "Are you sure you want to remove photo?": "Are you sure you want to remove photo?",
  "Are you sure you want to sign out?": "Are you sure you want to sign out?",
  "area": "area",
  "Arrival MVT has been sent": "Arrival MVT has been sent",
  "Arrival MVT not sent yet": "Arrival MVT not sent yet",
  "Arrival MVT sending": "Arrival MVT sending",
  "Arrival MVT sent successfully": "Arrival MVT sent successfully",
  "Attach photo": "Attach photo",
  "Attachment": "Attachment",
  "Aug": "Aug",
  "Available": "Available",
  "Belt": "Belt",
  "Body": "Body",
  "Briefly describe where the item will be stored for picking up.": "Briefly describe where the item will be stored for picking up.",
  "Call {{firstName}} {{lastName}}": "Call {{firstName}} {{lastName}}",
  "Call sign": "Call sign",
  "Cancel": "Cancel",
  "CANCEL": "CANCEL",
  "Cannot be after": "Cannot be after ",
  "Cannot be before": "Cannot be before ",
  "Cannot create MVT message: missing flight information": "Cannot create MVT message: missing flight information",
  "Cannot send Arrival MVT": "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.",
  "Cannot send MVT ETD": "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.",
  "Cannot set a future time.": "Cannot set a future time.",
  "Change": "Change",
  "Change password": "Change password",
  "Change password?": "Change password?",
  "Change your password:": "Change your password:",
  "Checked by (signature)": "Checked by (signature)",
  "Checks on easily visible parts of the aircraft from the ground": "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:",
  "Chocks": "Chocks",
  "Chute": "Chute",
  "CLEAR": "CLEAR",
  "Client's signature:": "Client's signature:",
  "Clocked Time": "Clocked Time",
  "Close": "Close",
  "CLOSE": "CLOSE",
  "Close all my sessions on all devices": "Close all my sessions on all devices",
  "Close registration": "Close registration",
  "CLOSE REGISTRATION": "CLOSE REGISTRATION",
  "close the flight": "close the flight",
  "Closed": "Closed",
  "Closing this window will discard all your recent changes.": "Closing this window will discard all your recent changes.",
  "Clouds": "Clouds",
  "Comment": "Comment",
  "Comment...": "Comment...",
  "Comments": "Comments",
  "Completed": "Completed",
  "Conditional services": "Conditional services",
  "Cones": "Cones",
  "CONFIRM": "CONFIRM",
  "Confirm": "Confirm",
  "Confirm new password": "Confirm new password",
  "Confirm remove?": "Confirm remove?",
  "CONFIRMED": "CONFIRMED",
  "Contact your administrator to request access": "Contact your administrator to request access",
  "Could not save data, please try again later": "Could not save data, please try again later",
  "Crew signature": "Crew signature",
  "Current password": "Current password",
  "Damage": "Damage",
  "Date range": "Date range",
  "Date should not be before start date": "Date should not be before start date",
  "Day": "Day",
  "Dec": "Dec",
  "DECLINED": "DECLINED",
  "Default station": "Default station",
  "Deicing": "Deicing",
  "Deicing Service Registration": "Deicing Service Registration",
  "Delete Photo": "Delete Photo",
  "DENIED": "DENIED",
  "Describe location": "Describe location",
  "Dest.": "Dest.",
  "Destination": "Destination",
  "Did you forget something?": "Did you forget something?",
  "Don't use phone while driving!": "Don't use phone while driving!",
  "Dummy Type": "Dummy Type",
  "Edit Comment": "Edit Comment",
  "Emergency": "Emergency",
  "Emergency contacts are not set up": "Emergency contacts are not set up.",
  "employees": "employees",
  "End": "End",
  "End of anti-icing": "End of anti-icing",
  "End Time": "End Time",
  "End time should not be before start time": "End time should not be before start time",
  "Entrance": "Entrance",
  "Error loading clocked times": "Error loading clocked times",
  "Error. The email doesn't meet standard formatting.": "Error. The email doesn't meet standard formatting.",
  "exceeds the allowed limit for this flight": " exceeds the allowed limit for this flight.",
  "Executor's name:": "Executor's name:",
  "Executor's signature:": "Executor's signature:",
  "extra service": "extra service",
  "Extra services": "Extra services",
  "Extra shift request": "Extra shift request",
  "Extra Shift Request": "Extra shift request",
  "Extra shift request confirmed": "Extra shift request confirmed",
  "failed": "failed",
  "Feb": "Feb",
  "Filter": "Filter",
  "Filter group": "Filter group",
  "Filter group has not been updated": "Filter group has not been updated",
  "filter group not found": "filter group not found",
  "finalization": "finalization",
  "Find the account recovery section and click \"Resend verification email\".": "Find the account recovery section and click \"Resend verification email\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: A document cannot be written because it exceeds the maximum size allowed",
  "Flight": "Flight",
  "Flight carrier": "Flight carrier",
  "Flight carrier is missing": "Flight carrier is missing",
  "Flight details": "Flight details",
  "Flight information registration": "Flight information registration",
  "Flight not found": "Flight not found",
  "Flight number/registration": "Flight number/registration",
  "Flight registration is closed": "Flight registration is closed.",
  "Flight reopened": "Flight reopened",
  "Flight type": "Flight type",
  "Flights": "Flights",
  "Fluid name": "Fluid name",
  "Fluid name:": "Fluid name:",
  "Fluid type": "Fluid type",
  "Forgot your password?": "Forgot your password?",
  "Forms": "Forms",
  "from": "from",
  "From": "From",
  "Full (Wings, stabilizer &, fuselage)": "Full (Wings, stabilizer &, fuselage)",
  "Future time is not allowed": "Future time is not allowed",
  "Gate": "Gate",
  "General info": "General info",
  "Go to flights": "Go to flights",
  "Go to login": "Go to login",
  "Go to My Profile in your Sunrise account.": "Go to My Profile in your Sunrise account.",
  "Go to Unread R&S": "Go to Unread R&S",
  "Helpdesk": "Helpdesk",
  "Hold Inspection on Arrival": "Hold Inspection on Arrival",
  "Hold Inspection on Departure": "Hold Inspection on Departure",
  "hr": "hr",
  "Humidity": "Humidity",
  "If damage is found, mark it on the sketch": "If damage is found, mark it on the sketch",
  "If the problem continues, go to My Profile to resend a new verification link.": "If the problem continues, go to My Profile to resend a new verification link.",
  "In order to close this flight you need to provide": "In order to close this flight you need to provide mandatory details.",
  "In order to close this flight you need to provide mandatory details.": "In order to close this flight you need to provide mandatory details.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "In order to open 'Calendar', read and process recent Read & Sign messages.",
  "In order to send Arrival MVT you need to provide mandatory details": "In order to send Arrival MVT you need to provide mandatory details",
  "Include nearby area": "Include nearby area",
  "Included nearby area": "Included nearby area",
  "Incorrect code": "Incorrect code",
  "Input a brief description here": "Input a brief description here",
  "Inspected by": "Inspected by",
  "Inspection agent's signature": "Inspection agent's signature:",
  "Inspection agent's signature:": "Inspection agent's signature:",
  "Inspections": "Inspections",
  "Instructions": "Instructions",
  "Internal communication": "Internal communication",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist",
  "is logged in": "is logged in",
  "Is Partial": "Is Partial",
  "is signed in": "is signed in",
  "It's safe and encrypted - only used for password resets.": "It's safe and encrypted — only used for password resets.",
  "Jan": "Jan",
  "Job vacancy": "Job vacancy",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "KEY PEOPLE",
  "Language": "Language",
  "Leave a comment about this timestamp and connected action.": "Leave a comment about this timestamp and connected action.",
  "Left Engine": "Left Engine",
  "Left Tail Wing": "Left Tail Wing",
  "Left Wing": "Left Wing",
  "Load Verification Cross-Check Form": "Load Verification Cross-Check Form",
  "Local (Under Wing / Local area contamination)": "Local (Under Wing / Local area contamination)",
  "Local Bags": "Local Bags",
  "Locked application": "Locked application",
  "Log in": "Log in",
  "Log out": "Log out",
  "Lost item": "Lost item",
  "lowercase": "lowercase",
  "Mar": "Mar",
  "Mark location": "Mark location",
  "May": "May",
  "Message archived": "Message archived",
  "Message state": "Message state",
  "Message type": "Message type",
  "Message unarchived": "Message unarchived",
  "Messages": "Messages",
  "messages yet": "messages yet",
  "min": "min",
  "Mix": "Mix",
  "Month": "Month",
  "MVT History": "MVT History",
  "My profile": "My profile",
  "Must be ULD code 3 chars + 4 or 5 digits (e.g. AKE12345)": "Must be ULD code 3 chars + 4 or 5 digits (e.g. AKE12345)",
  "Must be ULD code 3 chars + 4 or 5 digits + 2 or 3 char carrier (e.g. AKE12345BA)": "Must be ULD code 3 chars + 4 or 5 digits + 2 or 3 char carrier (e.g. AKE12345BA)",
  "Name Surname": "Name Surname",
  "Neck": "Neck",
  "New password": "New password",
  "New password cannot be equal to current": "New password cannot be equal to current",
  "New password does not meet security requirements": "New password does not meet security requirements",
  "next": "next",
  "Next 5 days": "Next 5 days",
  "No": "No",
  "No active flights yet": "No active flights yet",
  "No clocked times available": "No clocked times available",
  "No content yet...": "No content yet...",
  "No flight details information": "No flight details information",
  "No forms available for this flight": "No forms available for this flight",
  "No instructions found": "No instructions found",
  "No internet connection": "No internet connection.",
  "No key people assigned.": "No key people assigned.",
  "No messages yet": "No messages yet",
  "No photo available": "No photo available",
  "No photos here yet": "No photos here yet",
  "No registration": "No registration",
  "No services available": "No services available",
  "No time logging found": "No time logging found",
  "No timestamps configured for this flight type": "No timestamps configured for this flight type",
  "No types here yet": "No types here yet",
  "no user data": "no user data",
  "None": "None",
  "Nose": "Nose",
  "Not completed": "Not completed",
  "Note": "Note:",
  "Nov": "Nov",
  "NOW": "NOW",
  "Number of unread R&S:": "Number of unread R&S:",
  "numbers": "numbers",
  "occasion": "occasion",
  "Occasion": "Occasion",
  "Oct": "Oct",
  "Oops! It looks like your verification email didn't go through.": "Oops! It looks like your verification email didn't go through.",
  "Open": "Open",
  "Open a flight to add it to your active flights list.": "Open a flight to add it to your active flights list.",
  "Open file": "Open file",
  "Open flight {{name}}": "Open flight {{name}}",
  "Operation flight number": "Operation flight number",
  "Operator's name": "Operator's name",
  "Operator's name:": "Operator's name:",
  "Operator's signature": "Operator's signature",
  "Operator's signature:": "Operator's signature:",
  "Optional": "Optional",
  "or": "or",
  "Origin": "Origin",
  "Other flights": "Other flights",
  "Outside Air Temperature": "Outside Air Temperature (C°)",
  "Outside Air Temperature (C°)": "Outside Air Temperature (C°)",
  "Page not found": "Page not found",
  "Parking": "Parking",
  "Partially (Wings & stabilizer only)": "Partially (Wings & stabilizer only)",
  "Password": "Password",
  "Password must be at least 8 characters": "Password must be at least 8 characters long and contain at least 1 uppercase and 1 lowercase letter, 1 symbol, 1 digit and no whitespaces.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Password Not Unique. Your new password cannot be one of your last 5 used passwords.",
  "Passwords do not match": "Passwords do not match",
  "per occasion": "per occasion",
  "Per pax": "Per pax",
  "per start": "per start",
  "percent": "percent",
  "Photo registration": "Photo registration",
  "Photo types required": "Photo types required",
  "Photo types required:": "Photo types required:",
  "Photos": "Photos",
  "Pick if its a damaged part or lost item": "Pick if its a damaged part or lost item",
  "Pin on schema": "Pin on schema",
  "Please briefly describe where you found the item": "Please briefly describe where you found the item. Specify room or line and row if available",
  "Please click here to proceed to flights list": "Please click here to proceed to flights list",
  "Please make sure you attached photos of irregularities": "Please make sure you attached photos of irregularities",
  "Please pick on scheme": "Please pick on scheme",
  "Please reach out to your administrator for assistance": "Please reach out to your administrator for assistance.",
  "Please try sending it again later.": "Please try sending it again later.",
  "Please try the link again.": "Please try the link again.",
  "Please, sign below": "Please, sign below",
  "Post-deicing/anti-icing check completed": "Post-deicing/anti-icing check completed",
  "Precipitation": "Precipitation",
  "Pressure": "Pressure",
  "Proceed to login": "Proceed to login",
  "Product name": "Product name",
  "Product type": "Product type",
  "Profile": "Profile",
  "Profile data wasn't updated!": "Profile data wasn't updated!",
  "Psychosocial aid": "Psychosocial aid",
  "Quantity (liter)": "Quantity (liter)",
  "Read": "Read",
  "Read & Sign": "Read&Sign",
  "Read & Sign to do:": "Read & Sign to do:",
  "Read&Sign": "Read&Sign",
  "Receive Extra shift requests": "Receive Extra shift requests",
  "Receive job vacancies": "Receive job vacancies",
  recovery: {
    "error1": "<1>Oops!</1> It looks like your verification email didn't go through.",
    "error2": "<1>Please try sending it again later.</1>",
    "error3": "We apologize for the inconvenience.",
    "inUse": "This recovery email is already <1>in use!</1>",
    "success": "The <1>verification email</1> has been sent successfully!",
    validation: {
      "blockedDomainNote": "Any email with <1>@aviapartner.aero</1> or <3>@aviavip.com</3> is not accepted!",
      "invalidFormat": "Error. The email doesn't meet standard formatting."
    },
    "verified": "Your recovery email is already <1>verified!</1>"
  },
  "Recovery email": "Recovery email",
  "Recovery email already verified!": "Recovery email already verified!",
  "Recovery email verified!": "Recovery email verified!",
  "Reg.": "Reg.",
  "Registration": "Registration",
  "Registration Closed": "Registration Closed",
  "REGISTRATION CLOSED": "REGISTRATION CLOSED",
  "registration complete": "registration complete",
  "Remark": "Remark",
  "Remove": "Remove",
  "Remove {{name}} from active flights": "Remove {{name}} from active flights",
  "Reopen": "Reopen",
  "reopen flight": "reopen flight",
  "Report any irregularities found upon arrival": "Report any irregularities found upon arrival",
  "Report any other irregularities": "Report any other irregularities",
  "Required": "Required",
  "required to close the flight": "required to close the flight",
  "Requirements of the password are not met.": "Requirements of the password are not met.",
  "Resend verification email": "Resend verification email",
  "Right Engine": "Right Engine",
  "Right Tail Wing": "Right Tail Wing",
  "Right Wing": "Right Wing",
  "Runway": "Runway",
  "Safety Ramp Checklist": "Safety Ramp Checklist",
  "Safety Ramp Inspection": "Safety Ramp Inspection",
  "save": "save",
  "SAVE": "SAVE",
  "Save service registrations problem": "Save service registrations problem",
  "Screening": "Screening",
  "Scan ULD barcode": "Scan ULD barcode",
  "Search": "Search",
  "Seat": "Seat",
  "Seats": "Seats",
  "Select type": "Select type",
  "SEND ARRIVAL MVT": "SEND ARRIVAL MVT",
  "SEND CORRECTION ARRIVAL MVT": "SEND CORRECTION ARRIVAL MVT",
  "Send the Arrival MVT message to recipients:": "Send the Arrival MVT message to recipients:",
  "SENT": "SENT",
  "Sep": "Sep",
  "Service info saved": "Service info saved",
  "Service registration": "Service registration",
  "Service registration is closed": "Service registration is closed.",
  "Service Type": "Service Type",
  "Set": "Set",
  "Set date": "Set date",
  "Set time": "Set time",
  "Set time: End of anti-icing": "Set time: End of anti-icing",
  "Set to now": "Set to now",
  "Short remark": "Short remark",
  "Show": "Show",
  "Show Photo": "Show Photo",
  "Sign for understanding": "Sign for understanding",
  "Sign form below to complete it": "Sign form below to complete it:",
  "Sign in": "Sign in",
  "Sign out": "Sign out",
  "Signed": "Signed",
  "SKIP": "SKIP",
  "Skip this step": "Skip this step",
  "Something went wrong": "Something went wrong",
  "Something went wrong. Please try again later.": "Something went wrong. Please try again later.",
  "Something wrong": "Something wrong",
  "Sort.": "Sort.",
  "Specify where did you found the item": "Specify where did you found the item",
  "Start": "Start",
  "Start anti-icing": "Start anti-icing",
  "Start Time": "Start Time",
  "Station": "Station",
  "Stations": "Stations",
  "Stop anti-icing": "Stop anti-icing",
  "success": "success",
  "Sunrise": "Sunrise",
  "Sunset": "Sunset",
  "Switch flight": "Switch flight",
  "symbols": "symbols",
  "SYSTEM SETTINGS": "SYSTEM SETTINGS",
  "Tail": "Tail",
  "Take a photo": "Take a photo",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Take a photo of a finished action, this timestamp is dedicated to.",
  "Tap on area where damaged part is located": "Tap on area where damaged part is located",
  "Task": "Task",
  "Tasks & Flights": "Tasks & Flights",
  "Telex messages": "Telex messages",
  "Temperature (C°)": "Temperature (C°)",
  "The app has been updated": "The app has been updated",
  "The APPI code is required when resetting your Aviapartner": "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can always find your APPI code in your profile in Sunrise.",
  "the correction MVT will be sent": "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.",
  "The current password you entered is incorrect.": "The current password you entered is incorrect.",
  "The current password you've entered is incorrect": "The current password you've entered is incorrect. Please double-check and try again.",
  "The elapsed time between": "The elapsed time between ",
  "The end time must be later than the start time.": "The end time must be later than the start time.",
  "the MVT will be sent": "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.",
  "The planning shown below might not be up-to-date": "The planning shown below might not be up-to-date.",
  "The shift is already confirmed to": "The shift is already confirmed to",
  "The username or password you've entered is incorrect": "The username or password you've entered is incorrect. Please  double-check and try again.",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "The username or password you've entered is incorrect. Please double-check and try again.",
  "The verification email has been sent successfully!": "The verification email has been sent successfully!",
  "This action is mandatory.": "This action is mandatory.",
  "This field is mandatory": "This field is mandatory",
  "This form is signed": "This form is signed",
  "This message is marked as urgent": "This message is marked as urgent",
  "This recovery email is already in use!": "This recovery email is already in use!",
  "This request is not valid anymore": "This request is not valid anymore",
  "This section is used to deal with visible damage to the airplane": "This section is used to deal with visible damage to the airplane. Please document every noticeable issue before performing any services",
  "This service has been registered for this flight over 80% of the time.": "This service has been registered for this flight over 80% of the time.",
  "time": " time.",
  "Time registration": "Time registration",
  "Timeline": "Timeline",
  "Timestamp information": "Timestamp information",
  "Timestamps type": "Timestamps type",
  "to": "to",
  "To get a new one, simply follow these steps:": "To get a new one, simply follow these steps:",
  "Today": "Today",
  "TODAY": "TODAY",
  "Tomorrow": "Tomorrow",
  "Transfer Bags": "Transfer Bags",
  "Truck Driver": "Truck Driver",
  "Truck driver's signature": "Truck driver's signature:",
  "Truck driver's signature:": "Truck driver's signature:",
  "Truck Number": "Truck Number",
  "type": "type",
  "Type": "Type",
  "ULD carrier does not match the flight carrier": "ULD carrier does not match the flight carrier",
  "ULD ID": "ULD ID",
  "Unavailable": "Unavailable",
  "Unread": "Unread",
  "Until": "Until",
  "Unverified email": "Unverified email!",
  "uppercase": "uppercase",
  "Username": "Username",
  "Username or email": "Username or email",
  "validating": "validating",
  "validation": "validation",
  "Verification Error": "Verification Error",
  "Verification Link Expired": "Verification Link Expired",
  "Verified email": "Verified email",
  verify: {
    "alreadyVerifiedTitle": "Recovery email already verified!",
    "error1": "An error occurred while trying to verify your email address.",
    "error2": "Please try the link again.",
    "error3": "If the problem continues, go to <1>My Profile</1> to resend a new verification link.",
    "errorTitle": "Verification Error",
    "expiredStep1": "Go to <1>My Profile</1> in your Sunrise account.",
    "expiredStep2": "Find the account recovery section and click \"Resend verification email\".",
    "expiredStepsIntro": "To get a new one, simply follow these steps:",
    "expiredTitle": "Verification Link Expired",
    "successDescription": "You can now use it to regain access to your account if you forget your password.",
    "successTitle": "Recovery email verified!",
    "verifying": "Verifying..."
  },
  "Verifying...": "Verifying...",
  "View key people": "View key people",
  "Visibility": "Visibility",
  "Visual checks must be performed AFTER GSE removal": "Visual checks must be performed AFTER GSE removal",
  "Visual checks must be performed BEFORE GSE positioning": "Visual checks must be performed BEFORE GSE positioning",
  "Walkaround Arrival Checklist": "Walkaround Arrival Checklist",
  "Walkaround Pre-Departure Checklist": "Walkaround Pre-Departure Checklist",
  "We apologize for the inconvenience.": "We apologize for the inconvenience.",
  "We strongly recommend saving it in your smartphone phonebook": "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.",
  "Weather": "Weather",
  "Wind": "Wind",
  "Would you like to add it to your current registration?": "Would you like to add it to your current registration?",
  "Write comment": "Write comment",
  "write new comment": "write new comment",
  "Write your comment here, then press the green check mark": "Write your comment here, then press the green check mark",
  "Year": "Year",
  "Yes": "Yes",
  "Yesterday": "Yesterday",
  "You are offline": "You are offline.",
  "You can check your APPI code on Sunrise portal.": "You can check your APPI code on Sunrise portal.",
  "You can now use it to regain access to your account if you forget your password.": "You can now use it to regain access to your account if you forget your password.",
  "You can't remove this temporal item": "You can't remove this temporal item",
  "You don't have permission to view clocked times": "You don't have permission to view clocked times",
  "You don't have permissions to take a photo": "You don't have permissions to take a photo",
  "You were signed out automatically": "You were signed out automatically. Token has expired. You can sign back in with your credentials",
  "Your password and confirmation password do not match": "Your password and confirmation password do not match.",
  "Your password has been changed successfully!": "Your password has been changed successfully!",
  "Your password has expired. Please compose a new password and log in again.": "Your password has expired. Please compose a new password and log in again.",
  "Your password must contain at least eight characters": "Your password must contain at least eight characters",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.",
  "Your recovery email is already verified!": "Your recovery email is already verified!",
  "Your session has expired. Please sign in again.": "Your session has expired. Please sign in again."
};
